import { KnowledgeBaseFacade } from '@agent/core/store/knowledge-base/knowledge-base.facade';
import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { BookingFacade, ChanEnum, Formly, UntilDestroy } from '@contact/upgrade';

import { ResponseModel } from './models/responseModel';
import { KnowledgeBaseOwiService } from './owi/services/knowledge-base-OWI.service';

export const AGENT_KNOWLEDGE_BASE_SEARCH_FORMLY = new InjectionToken<Formly>('AGENT_KNOWLEDGE_BASE_SEARCH_FORMLY');
export const AGENT_KNOWLEDGE_BASE_SEARCH_FORM_ID = 'AGENT_KNOWLEDGE_BASE_SEARCH_FORMLY';

export enum KnowledgeBaseTabs {
  SUGGESTIONS,
  TREE,
  SEARCH,
}

export enum SearchFilter {
  SEARCH_VALUE = 'SEARCH_VALUE',
}

@UntilDestroy()
@Component({
  selector: 'cng-knowledge-base-owi',
  templateUrl: 'knowledge-base-OWI.component.html',
  styleUrls: ['./knowledge-base-OWI.component.scss'],
  providers: [
    {
      provide: AGENT_KNOWLEDGE_BASE_SEARCH_FORMLY,
      useClass: Formly,
    },
  ],
})
export class ContactKnowledgeBaseOwiComponent implements OnInit {
  readonly formlyForm = this.formly.form;
  readonly Filter = SearchFilter;
  readonly searchValueChanged$ = this.formly.replayValueChanges(SearchFilter.SEARCH_VALUE);

  searchValue: string = '';
  searchText: string = '';
  searchResults: ResponseModel[] = [];
  suggestedResults: ResponseModel[] = [];
  mediaExternalId: string | number | undefined = '';
  selectedTab: KnowledgeBaseTabs = 0;
  outgoingMailOpened: boolean = false;

  searchResults$ = this.knowledgeBaseFacade.searchResults$;

  constructor(
    private readonly knowledgeBaseFacade: KnowledgeBaseFacade,
    private readonly contactFacade: BookingFacade,
    private knowledgeBaseOwiService: KnowledgeBaseOwiService,
    @Inject(AGENT_KNOWLEDGE_BASE_SEARCH_FORMLY) private readonly formly: Formly
  ) {
    this.formly.setId(AGENT_KNOWLEDGE_BASE_SEARCH_FORM_ID);
  }

  ngOnInit(): void {
    this.formly.init({
      [SearchFilter.SEARCH_VALUE]: new FormControl(undefined),
    });

    this.searchValueChanged$.subscribe((value: string) => (this.searchValue = value));

    this.contactFacade.selected$.subscribe(() => {
      this.mediaExternalId = this.knowledgeBaseOwiService.getMediaExternalId();
    });

    this.knowledgeBaseFacade.suggestedResults$.subscribe((suggestedResults: ResponseModel[]) => {
      this.suggestedResults = suggestedResults;
      if (suggestedResults.length) {
        this.selectedTab = KnowledgeBaseTabs.SUGGESTIONS;
      }
    });
    this.searchResults$.subscribe((data: ResponseModel[]) => (this.searchResults = data));

    this.contactFacade.getByChannel(ChanEnum.Unit.Mail).subscribe(contact => (this.outgoingMailOpened = !!contact.length));
  }

  search(): void {
    this.selectedTab = KnowledgeBaseTabs.SEARCH;
    this.searchText = this.searchValue;
  }

  resetSearch(): void {
    this.searchValue = '';
    this.searchText = '';
    this.knowledgeBaseFacade.searchResults([]);
    this.formly.erase();
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.selectedTab = tabChangeEvent.index;
  }
}
